export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (String(time).length === 10) time = parseInt(time, 10) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  }
  const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') {
      return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return timeStr
}

export function formatTime(time, option) {
  time = Number(time) * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  }
  return (
    d.getMonth() +
    1 +
    '月' +
    d.getDate() +
    '日' +
    d.getHours() +
    '时' +
    d.getMinutes() +
    '分'
  )
}

export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"') +
      '"}',
  )
}

export function contrastObj(newObj, oldObj) {
  const oTemp = {}
  for (const i in newObj) {
    if (Array.isArray(newObj[i])) {
      if (typeof oldObj[i] !== 'undefined') {
        if (newObj[i].join() !== oldObj[i].join()) {
          oTemp[i] = newObj[i]
        }
      } else {
        oTemp[i] = newObj[i]
      }
    } else {
      if (typeof oldObj[i] !== 'undefined') {
        if (String(newObj[i]) !== String(oldObj[i])) {
          oTemp[i] = newObj[i]
        }
      } else {
        oTemp[i] = newObj[i]
      }
    }
  }
  return oTemp
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function () {
    // 据上一次触发时间间隔
    const last = Number(new Date()) - timestamp

    // 上次被包装函数被调用时间间隔last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function (...args) {
    // eslint-disable-next-line consistent-this
    context = this
    timestamp = Number(new Date())
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

// 是否含有中文
export function hasChinese(str) {
  const pattern = new RegExp('[\u4E00-\u9FA5]+')
  return pattern.test(str)
}

export function toThousands(num) {
  let bHasPoint = false
  if (String(num).indexOf('.') !== -1) {
    bHasPoint = true
  }
  const s = String(parseFloat(String(num).replace(/[^\d.-]/g, '')))
  const l = s.split('.')[0].split('').reverse()
  const r = s.split('.')[1] ? s.split('.')[1] : '00'
  let t = ''
  for (let i = 0; i < l.length; i++) {
    t += l[i] + ((i + 1) % 3 === 0 && i + 1 !== l.length ? ',' : '')
  }
  if (bHasPoint) {
    return t.split('').reverse().join('') + '.' + r
  }
  return t.split('').reverse().join('')
}

export function changeFullShaped(string) {
  return string.replace(/（/g, '(').replace(/）/, ')')
}

export function transBase64FromImageUrl(imageUrl) {
  const image = new Image()
  const type = imageUrl.split('.')[imageUrl.split('.').length - 1]

  return new Promise((resolve, reject) => {
    image.crossOrigin = '*'
    image.src = imageUrl + '?v=2' // 避免缓存
    image.onload = () => {
      const canvas = document.createElement('canvas')
      canvas.width = image.width
      canvas.height = image.height
      const ctx = canvas.getContext('2d')
      ctx.drawImage(image, 0, 0, image.width, image.height)
      const output = type.indexOf('png') === -1 ? 'image/jpeg' : 'image/png'
      resolve(canvas.toDataURL(output))
    }
    image.onerror = () => {
      reject(new Error('图片加载不成功'))
    }
  })
}

/**
 * 更新或添加URL参数（支持自定义URL输入）
 * @param {string} url - 原始URL
 * @param {string} key - 参数名
 * @param {string} value - 参数值
 * @returns {string} 更新后的完整URL
 */
export function updateUrlParam(url, key, value) {
  // 1. 解析传入的URL
  const urlObj = new URL(url)

  // 2. 更新或添加参数
  urlObj.searchParams.set(key, value)

  // 3. 返回更新后的URL（保留hash）
  return urlObj.toString()
}
